"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ecommerce_1 = require("../../../api/ecommerce");
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const array_1 = require("../../../common/js/helper/array");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const UserProfileAddress_1 = __importDefault(require("../../atoms/UserProfileAddress"));
const MassiveCompany_1 = __importDefault(require("../../stores/MassiveCompany"));
class UserProfileAccountPersonalData extends react_1.default.Component {
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            showEditButton: mobx_1.computed,
        });
    }
    get showEditButton() {
        return AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.PROFILE_UPDATE);
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('profile_subpage_title', { title: (0, translation_1.t)('user.profile.account.title') });
        if (!MassiveCompany_1.default.customer) {
            MassiveCompany_1.default.loadCompany();
        }
    }
    render() {
        const massiveCustomer = MassiveCompany_1.default.massiveCustomer;
        const shopwareCustomer = MassiveCompany_1.default.customer;
        if (!massiveCustomer?.externalId || !shopwareCustomer) {
            return (react_1.default.createElement("div", { className: "h-100 d-flex align-items-center justify-content-center" }, (0, translation_1.t)('user.profile.empty_content')));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h2", { className: "znd-user-profile-page__content-data-title t-headline-3" }, (0, translation_1.t)('user.profile.personal')),
            react_1.default.createElement("div", { className: "znd-user-profile-page__content-data-group" }, massiveCustomer && shopwareCustomer ? (react_1.default.createElement(UserProfileAddress_1.default, { className: "znd-user-profile-page__content-data-item", title: (0, translation_1.t)('user.profile.account.card.title'), address: {
                    company: massiveCustomer.customer?.company ?? undefined,
                    department: massiveCustomer?.department ?? undefined,
                    email: shopwareCustomer?.email,
                    externalId: massiveCustomer?.externalId ?? undefined,
                    name1: shopwareCustomer?.lastName,
                    name2: shopwareCustomer?.firstName,
                    name: (0, array_1.concat)([
                        MassiveCompany_1.default.salutationDisplayName,
                        shopwareCustomer?.firstName,
                        shopwareCustomer?.lastName,
                    ].filter((value) => !!value), ' '),
                    phoneNumber1: massiveCustomer?.phoneNumber1 ?? undefined,
                    phoneNumber2: massiveCustomer?.phoneNumber2 ?? undefined,
                    role: massiveCustomer?.role ?? undefined,
                    salutation: MassiveCompany_1.default.salutation?.salutationKey,
                }, editable: this.showEditButton, changeRequestObject: ecommerce_1.ChangeRequestObjectEnum.PersonalContact, changeRequestTopic: ecommerce_1.ChangeRequestTopicEnum.Contact })) : null)));
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(UserProfileAccountPersonalData));
